module.exports = __webpack_public_path__ + "static/media/logo.ae31d989.png";